import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';
import { appointmentAllCount, doctorAppointmentAllCount } from './Admin.action';
import { allDoctorAppointment } from './Doctor.action';

export const CREATE_LEAD = 'CREATE_LEAD';
export const GET_ALL_LEAD = 'GET_ALL_LEAD';
export const UPDATE_LEAD = 'UPDATE_LEAD';
export const DELETE_LEAD = 'DELETE_LEAD';
export const VERIFY_OTP = 'VERIFY_OTP';
export const SEARCH_LEAD = 'SEARCH_LEAD';
export const VIEW_LEAD = 'VIEW_LEAD';
export const ALL_PATIENT = 'ALL_PATIENT';
export const ALL_PATIENT_SEARCH = 'ALL_PATIENT_SEARCH';
export const ALL_BRANCH = 'ALL_BRANCH';
export const ALL_DOCTOR = 'ALL_DOCTOR';
export const ALL_DOCTOR_SEARCH = 'ALL_DOCTOR_SEARCH';
export const ALL_COUNSELOR = 'ALL_COUNSELOR';
export const SEARCH_ALL_COUNSELOR = 'SEARCH_ALL_COUNSELOR';
export const GET_FOLLOWUP = 'GET_FOLLOWUP';
export const GET_NEXT_FOLLOWUP = 'GET_NEXT_FOLLOWUP';
export const ADD_BULK_DATA = 'ADD_BULK_DATA';
export const GET_PATIENT_EXCEL = 'GET_PATIENT_EXCEL';
export const GET_DYNAMIC_FIELDS = 'GET_DYNAMIC_FIELDS';

const leadCreateAction = (payload) => ({ type: CREATE_LEAD, payload: payload });
const leadGetAction = (payload) => ({ type: GET_ALL_LEAD, payload: payload });
const leadUpdateAction = (payload) => ({ type: UPDATE_LEAD, payload: payload });
const leadDeleteAction = (payload) => ({ type: DELETE_LEAD, payload: payload });
const verifyOtpAction = (payload) => ({ type: VERIFY_OTP, payload: payload });
const leadSearchAction = (payload) => ({ type: SEARCH_LEAD, payload: payload });
const leadViewAction = (payload) => ({ type: VIEW_LEAD, payload: payload });
const allPatientpAction = (payload) => ({
  type: ALL_PATIENT,
  payload: payload,
});
const allPatientSearchpAction = (payload) => ({
  type: ALL_PATIENT_SEARCH,
  payload: payload,
});
const allBranchAction = (payload) => ({ type: ALL_BRANCH, payload: payload });
const allDoctorAction = (payload) => ({ type: ALL_DOCTOR, payload: payload });
const allDoctorSearchAction = (payload) => ({
  type: ALL_DOCTOR_SEARCH,
  payload: payload,
});
const allCounselorAction = (payload) => ({
  type: ALL_COUNSELOR,
  payload: payload,
});
const searchallCounselorAction = (payload) => ({
  type: SEARCH_ALL_COUNSELOR,
  payload: payload,
});
const getFollowupAction = (payload) => ({
  type: GET_FOLLOWUP,
  payload: payload,
});
const getNextFollowupAction = (payload) => ({
  type: GET_NEXT_FOLLOWUP,
  payload: payload,
});
const addBulkDataAction = (payload) => ({
  type: ADD_BULK_DATA,
  payload: payload,
});
const getPatientExcelAction = (payload) => ({
  type: GET_PATIENT_EXCEL,
  payload: payload,
});
const getDynamicFieldsAction = (payload) => ({
  type: GET_DYNAMIC_FIELDS,
  payload: payload,
});

export const leadCreate = (payload, limits, status) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(`${BASEURL}/receptionist/registerPatient`, payload, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success('Lead Create successfully');
          dispatch(leadCreateAction(res));
          dispatch(leadGet(limits, status));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message);
          dispatch(leadCreateAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Erro File Create', error);
    }
  };
};

export const leadGet = (payload, status) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    try {
      await axios
        .get(
          `${BASEURL}/receptionist/searchPatient?${new URLSearchParams(
            Object.fromEntries(
              Object.entries({
                limit: payload.limit,
                page: payload.page,
                search: payload.search,
                startDate: payload.startDate,
                endDate: payload.endDate,
                status: payload.status,
                managerId: payload.managerId,
                update_at: payload.update_at,
              }).filter(([, v]) => v !== undefined && v !== null && v !== ''),
            ),
          ).toString()}`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          dispatch(leadGetAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(leadGetAction(error?.response));
        });
    } catch (error) {
      console.log('Error login user:', error);
    }
  };
};

export const getDynamicFields = (id) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/receptionist/dataWithQuestions/${id}`)
        .then((res) => {
          dispatch(getDynamicFieldsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getDynamicFieldsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const updateLead = (payload, limits, status, queryParams) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .put(`${BASEURL}/receptionist/upadtePatient`, payload, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success('Update Lead successfully');
          dispatch(leadUpdateAction(res));
          // dispatch(leadGet(limits, status));
          dispatch(getFollowup(queryParams));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message);
          dispatch(leadUpdateAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const deleteLead = (payload, limits, status) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(`${BASEURL}/receptionist/deletePatient`, payload, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success('Delete Lead successfully');
          dispatch(leadDeleteAction(res));
          dispatch(leadGet(limits, status));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message);
          dispatch(leadDeleteAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const searchLead = (queryParams) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/receptionist/searchPatient?${queryParams}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(leadSearchAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(leadSearchAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const verifyOtp = (payload) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(`${BASEURL}/receptionist/deletePatient`, payload, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          toast.success('Send Otp to Master successfully');
          dispatch(verifyOtpAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message);
          dispatch(verifyOtpAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const viewLead = (id) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/receptionist/getPatientById/${id}`)
        .then((res) => {
          dispatch(leadViewAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(leadViewAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const patientData = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/receptionist/getAllPatientForDropDown`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(allPatientpAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(allPatientpAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const patientSearchData = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(
          `${BASEURL}/receptionist/searchPatientForDropDown?search=${params}`,
          {
            headers: {
              authorization: `Bearer ${token}`,
            },
          },
        )
        .then((res) => {
          dispatch(allPatientSearchpAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(allPatientSearchpAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const allBranchDetail = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');

      await axios
        .get(`${BASEURL}/master/dropDownGetAllBranches`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(allBranchAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(allBranchAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const allDoctorDetail = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');

      await axios
        .get(`${BASEURL}/master/getAllDoctorForDropDown`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(allDoctorAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(allDoctorAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const allDoctorSearchDetail = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');

      await axios
        .get(`${BASEURL}/master/searchDoctorForDropDown?search=${params}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(allDoctorSearchAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(allDoctorSearchAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const allCounselorDetail = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/auth/getRegisteredCounselor`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(allCounselorAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(allCounselorAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const searchAllCounselorDetail = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/auth/searchCounselorsByName?search=${params.search}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(searchallCounselorAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(searchallCounselorAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const getFollowup = (queryParams) => {
  return async (dispatch) => {
    const token = localStorage.getItem('token');
    try {
      if (queryParams?.date) {
        await axios
          .get(
            `${BASEURL}/receptionist/dateWiseFollowupDate?page=${queryParams?.page}&limit=${queryParams?.limit}&date=${queryParams?.date}&searchQuery=${queryParams?.search}&managerId=${queryParams?.managerId}`,
            {
              headers: {
                authorization: `Bearer ${token}`,
              },
            },
          )
          .then((res) => {
            dispatch(getFollowupAction(res));
          })
          .catch((error) => {
            console.log('Error', error);
            dispatch(getFollowupAction(error?.response));
          });
      } else {
        await axios
          .get(
            `${BASEURL}/receptionist/dateWiseFollowupDate?page=${queryParams?.page}&limit=${queryParams?.limit}&searchQuery=${queryParams?.search}&managerId=${queryParams?.managerId}`,
            {
              headers: {
                authorization: `Bearer ${token}`,
              },
            },
          )
          .then((res) => {
            dispatch(getFollowupAction(res));
          })
          .catch((error) => {
            console.log('Error', error);
            dispatch(getFollowupAction(error?.response));
          });
      }
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const getNextFollowup = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/receptionist/getAllFollowupDate`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(getNextFollowupAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getNextFollowupAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const addBulkData = (payload, limits, status) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(`${BASEURL}/receptionist/uploadBulkPatientData`, payload, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(addBulkDataAction(res));
          dispatch(leadGet(limits, status));
          toast.success('Add Data Successfully!');
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(error?.response?.data?.message);
          dispatch(addBulkDataAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const getPatientExcelData = (queryParams) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const queryString = new URLSearchParams(queryParams).toString();
      await axios
        .get(`${BASEURL}/receptionist/searchPatientExport?${queryString}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          dispatch(getPatientExcelAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getPatientExcelAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const GET_WORK_REPORT = 'GET_WORK_REPORT';
const getWorkReportAction = (payload) => ({
  type: GET_WORK_REPORT,
  payload: payload,
});

export const getWorkReport = (params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const queryParams = new URLSearchParams(params).toString();
      await axios
        .get(`${BASEURL}/receptionist/workReport?${queryParams}`, {
          headers: { authorization: `Bearer ${token}` },
        })
        .then((res) => {
          dispatch(getWorkReportAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          toast.error(
            error?.response?.data?.message || 'Failed to load report',
          );
          dispatch(getWorkReportAction(error?.response));
        });
    } catch (error) {
      console.log('Error fetching work report:', error);
    }
  };
};
